import * as React from 'react'

import { useTranslation } from '../../../../../../app/_providers/TranslationProvider.client'
import { useEmbroideryGarment } from '../../../../../../containers/EmbroideryContainer/providers/EmbroideryGarmentProvider'
import { EmbroideryColor } from '../../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { ColorSelector } from '../../../primitives/selectors/ColorSelector/ColorSelector'

export type TextColorPickerProps = {
  selectedColor: EmbroideryColor | undefined
  onSelectColor(color: EmbroideryColor): void
  errorMessage?: string
  disabled?: boolean
}

export const TextColorPicker: React.FC<TextColorPickerProps> = ({
  selectedColor,
  onSelectColor,
  errorMessage,
  disabled,
}) => {
  const { productColorHex } = useEmbroideryGarment()
  const {
    embroidery: {
      modal: {
        forms: { textOption },
      },
    },
  } = useTranslation()

  return (
    <ColorSelector
      // Temporary unblocking of colors for DTC. Remove this in LFE-187
      colorRestrictions={[]}
      disabled={disabled}
      errorMessage={errorMessage}
      label={textOption.textColorLabel}
      onSelectColor={onSelectColor}
      productColorHex={productColorHex}
      selectedColor={selectedColor}
    />
  )
}
